import React from 'react';
import { SearchField } from '@/components/custom/erp';
import { FormField } from '@/components/custom/erp';
import { NhomLoaiHD } from '@/types/schemas/nhom-loai-hd.type';
import QUERY_KEYS from '@/constants/query-keys';
import { Label } from '@/components/ui/label';

interface BasicInfoTabProps {
  formMode: 'add' | 'edit' | 'view';
  nhomLoaiHD: NhomLoaiHD | null;
  setNhomLoaiHD: (nhomLoaiHD: NhomLoaiHD) => void;
}

const nhomLoaiHDColumns = [
  {
    field: 'ma_nhom',
    headerName: 'Mã loại hd',
    width: 150
  },
  {
    field: 'ten_nhom',
    headerName: 'Tên loại hóa đơn',
    width: 250
  }
];
const BasicInfoTab: React.FC<BasicInfoTabProps> = ({ formMode, nhomLoaiHD, setNhomLoaiHD }) => {
  const isDisabled = formMode === 'view';

  return (
    <div className='min-w-[48vw] p-4 md:p-6'>
      <div className='flex flex-col gap-y-4 md:gap-y-6'>
        <div className='space-y-4'>
          <div className='flex flex-col sm:flex-row sm:items-center'>
            <Label className='mb-2 sm:mb-0 sm:w-40 sm:min-w-40'>Mã mẫu số</Label>
            <FormField type='text' name='ma_mau_so' disabled={isDisabled} />
          </div>

          <div className='flex flex-col sm:flex-row sm:items-center'>
            <Label className='mb-2 sm:mb-0 sm:w-40 sm:min-w-40'>Tên mẫu số</Label>
            <FormField type='text' name='ten_mau_so' disabled={isDisabled} />
          </div>

          <div className='flex flex-col sm:flex-row sm:items-center'>
            <Label className='mb-2 sm:mb-0 sm:w-40 sm:min-w-40'>Tên khác</Label>
            <FormField type='text' name='ten_mau_so2' disabled={isDisabled} />
          </div>

          <div className='flex flex-col sm:flex-row sm:items-center'>
            <Label className='mb-2 sm:mb-0 sm:w-40 sm:min-w-40'>Nhóm loại HĐ</Label>
            <SearchField<NhomLoaiHD>
              disabled={isDisabled}
              searchEndpoint={`/${QUERY_KEYS.NHOM_LOAI_HD}/`}
              searchColumns={nhomLoaiHDColumns}
              displayRelatedField='ten_nhom'
              columnDisplay='ma_nhom'
              dialogTitle='Danh mục nhóm loại hóa đơn'
              value={nhomLoaiHD?.ma_nhom || ''}
              onRowSelection={setNhomLoaiHD}
              className='w-100'
            />
          </div>

          <div className='flex flex-col sm:flex-row sm:items-center'>
            <Label className='mb-2 sm:mb-0 sm:w-40 sm:min-w-40'>Mẫu HĐĐT</Label>
            <div className='flex items-center'>
              <FormField type='checkbox' name='hddt_yn' disabled={isDisabled} />
            </div>
          </div>

          <div className='flex flex-col sm:flex-row sm:items-center'>
            <Label className='mb-2 sm:mb-0 sm:w-40 sm:min-w-40'>Trạng thái</Label>
            <FormField
              type='select'
              name='status'
              disabled={isDisabled}
              options={[
                { label: '1. Còn sử dụng', value: '1' },
                { label: '0. Không sử dụng', value: '0' }
              ]}
              defaultValue='1'
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default BasicInfoTab;
